import Vue from 'vue/dist/vue.esm';
import Vuex from 'vuex';
import notice from '@v2/store/modules/u/notice';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';
import NoticeBellContainer from '@v2/organisms/u/notice/NoticeBellContainer.vue';

// font-awesome
library.add(fas, far, fab);
Vue.component('FontAwesomeIcon', FontAwesomeIcon);
Vue.component('FontAwesomeLayers', FontAwesomeLayers);
Vue.component('AppNoticeBellContainer', NoticeBellContainer);

Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    notice,
  },
});

document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    store,
  }).$mount('#notice-bellArea');
});
